import * as React from "react";
import { IOpLabelValue } from "../../../../types/components/orderPlacement/opTypes";
import DeviceContext from "../../../../service/indentifyDevice";

export interface IOpQuotesHoldingsProps {
	data: Array<IOpLabelValue>;
	hldgOrPos: "holding" | "position";
}

const OpQuotesHoldings: React.FC<IOpQuotesHoldingsProps> = props => {
	return (
		<div className="op_quotes_holdings">
			{DeviceContext().isDesktop && <div className="floating_title">YOUR {props.hldgOrPos.toUpperCase()}</div>}
			{props.data.map(d => (
				<div className="row" key={d.label}>
					<span className="label">{d.label}</span>
					<span className={"value" + (d.label === "Unrealised G/L" ? " green" : "")}>{d.value}</span>
				</div>
			))}
		</div>
	);
};

export default OpQuotesHoldings;
